import { render, staticRenderFns } from "./create_single_group.vue?vue&type=template&id=5a5327a0&scoped=true&"
import script from "./create_single_group.vue?vue&type=script&lang=ts&"
export * from "./create_single_group.vue?vue&type=script&lang=ts&"
import style0 from "./create_single_group.vue?vue&type=style&index=0&id=5a5327a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5327a0",
  null
  
)

export default component.exports